import { Component } from 'react';

/**
 * Error Boundary — catches React rendering crashes and shows a recovery UI
 * instead of a black screen. Wraps the entire app in App.js.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    try {
      // Report to Sentry
      if (window.Sentry) {
        window.Sentry.captureException(error, { extra: { componentStack: errorInfo.componentStack } });
      }
    } catch {}
  }

  render() {
    if (this.state.hasError) {
      // Scoped boundary — caller supplied a compact fallback
      if (this.props.fallback) {
        return typeof this.props.fallback === 'function'
          ? this.props.fallback(this.state.error)
          : this.props.fallback;
      }
      return (
        <div style={{
          minHeight: '100vh', background: '#0a0907', display: 'flex',
          alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Sans', sans-serif",
        }}>
          <div style={{ textAlign: 'center', maxWidth: 400, padding: 40 }}>
            {/* The wordmark (components/Wordmark.js), inline: this screen must draw with nothing else loaded */}
            <div style={{ fontSize: 48, marginBottom: 16, fontFamily: 'Anton, Impact, sans-serif', textTransform: 'uppercase',
                          letterSpacing: '-0.02em', lineHeight: 1 }}>
              <span style={{ color: '#f4f4f5' }}>Uncut</span><span style={{ color: '#2bb3a8' }}>Gems</span>
            </div>
            <h2 style={{ color: '#f4f4f5', fontSize: 18, marginBottom: 8 }}>Something went wrong</h2>
            <p style={{ color: '#71717a', fontSize: 13, lineHeight: 1.6, marginBottom: 24 }}>
              The page encountered an error. Your data is safe — try refreshing.
            </p>
            <button onClick={() => window.location.reload()} style={{
              background: '#c6a96f', color: '#0a0907', fontWeight: 700, fontSize: 14,
              padding: '12px 32px', borderRadius: 12, border: 'none', cursor: 'pointer',
              letterSpacing: '0.02em',
            }}>
              Refresh Page
            </button>
            <p style={{ color: '#8e8e96', fontSize: 10, marginTop: 16 }}>
              If this keeps happening, contact hello@uncutgems.com
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
